import { Sparkle } from "lucide-react";
import { MARQUEE } from "../data/cv";

export default function Marquee() {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div className="marquee relative border-y border-white/[0.07] bg-panel/40 py-5 overflow-hidden" data-testid="marquee">
      <div className="absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-ink to-transparent" />
      <div className="absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-ink to-transparent" />
      <div className="marquee-track items-center gap-10 pr-10">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className={`font-display text-sm sm:text-base tracking-wide ${i % 2 ? "text-slate-300" : "text-slate-400"}`}>
              {item}
            </span>
            <Sparkle size={11} className={i % 2 ? "text-vio/70" : "text-neon/70"} />
          </span>
        ))}
      </div>
    </div>
  );
}